<form [formGroup]="form">
  @for (group of parameters; track group; let index = $index) {
    <div
      class="report-parameter"
         [ngClass]="{
            'ask-parameter-container': !!formService.config[index]?.showAskParameterOption,
            'bool-parameter-container': formService.config[index]?.type === 'bool',
            'open-or-closed-parameter-container': formService.config[index]?.type === 'openOrClosed'
         }"
      >
      <ng-container
        [ndtDynamicReportParameter]
        [config]="formService.config[index]"
        [componentAccessor]="componentAccessor"
        [group]="group"
        >
      </ng-container>
    </div>
  }
</form>
